import { isEmpty } from "@/utils/common-helpers"
import { clsx } from "clsx"
import { AsyncPaginate } from "react-select-async-paginate"

const CustomAsyncPaginateStatic = ({
  data,
  selectedData,
  setSelectedData,
  handleChange,
  validation = "",
  placeholder,
}: any) => {
  const fetchData = async () => {
    return {
      options: data,
      hasMore: false,
    }
  }

  return (
    <>
      <AsyncPaginate
        loadOptions={fetchData}
        id="contact_form_dropdown"
        isSearchable={false}
        className={clsx("react-select-container", validation)}
        classNamePrefix="react-select"
        placeholder={placeholder}
        onChange={(e: any) => {
          if (!isEmpty(handleChange)) {
            handleChange(e)
          }
          setSelectedData(e)
        }}
        value={selectedData}
      />
    </>
  )
}

export default CustomAsyncPaginateStatic
